import { createFileRoute } from '@tanstack/react-router';
import ManageTerminalContactsView from '../terminal/ManageTerminalContactsView';
export const Route = createFileRoute('/terminals/locations/$terminalId_/contacts')({
  component: ManageTerminalContactsView,
});
